import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import StaticBlogToolsSidebar from '../components/StaticBlogToolsSidebar';
import Seo from '../seo/Seo';
import { GALLERY_HUB } from '../seo/landingData';
import { GALLERY_HUB_MAIN_HTML } from '../content/galleryHubMainHtml';

function GalleryHubPage() {
  return (
    <div className="page landing-bg static-blog-page">
      <Seo
        title={GALLERY_HUB.title}
        description={GALLERY_HUB.description}
        canonicalPath="/gallery/"
        keywords={GALLERY_HUB.keywords}
      />
      <Helmet>
        <link rel="stylesheet" href="/blog/blog-static.css" />
        <link rel="stylesheet" href="/gallery/gallery-static.css" />
      </Helmet>
      <Navbar />
      <main className="static-main">
        <div className="blog-layout">
          <StaticBlogToolsSidebar />
          <div
            className="blog-page-main static-gallery-hub-main"
            dangerouslySetInnerHTML={{ __html: GALLERY_HUB_MAIN_HTML }}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default GalleryHubPage;
